import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import React, { useState } from "react";
import ImageDialog from "./ImageDialog";


const BraceletsSizeDialog = ({ isOpen, onClose }) => {

    const [isShowMeasurement, setShowMeasurement] = useState(false);

    const sizeChartData = [
        { womenLabel: "X-Small (XS)", menLabel: "N/A", sizeInch: "5 - 5.5", sizeCm: "12.7 - 14.0" },
        { womenLabel: "Small (S)", menLabel: "N/A", sizeInch: "5.5 - 6", sizeCm: "14.0 - 15.2" },
        { womenLabel: "Medium (M)", menLabel: "N/A", sizeInch: "6 - 6.5", sizeCm: "15.2 - 16.5" },
        { womenLabel: "Large (L)", menLabel: "Small (S)", sizeInch: "6.5 - 7", sizeCm: "16.5 - 17.8" },
        { womenLabel: "X-Large (XL)", menLabel: "Medium (M)", sizeInch: "7 - 7.5", sizeCm: "17.8 - 19" },
        { womenLabel: "2X-Large (2XL)", menLabel: "Large (L)", sizeInch: "7.5 - 8", sizeCm: "19 - 20.3" },
        { womenLabel: "3X-Large (3XL)", menLabel: "X-Large (XL)", sizeInch: "8 - 8.5", sizeCm: "20.3 - 21.6" },
        { womenLabel: "N/A", menLabel: "2X-Large (2XL)", sizeInch: "8.5 - 9", sizeCm: "21.6 - 22.9" },
        { womenLabel: "N/A", menLabel: "3X-Large (3XL)", sizeInch: "9 - 9.5", sizeCm: "22.9 - 24.1" },
    ];

    return (
        <div>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[10000]" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-xl transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-md md:text-lg font-medium leading-6 text-gray-900"
                                    >
                                        Bracelet Size Chart (Indian Size)
                                    </Dialog.Title>
                                    <div className="w-full h-auto pt-2">
                                        <div className="w-full flex flex-col gap-5">

                                            {/* <table className=" border-collapse border border-slate-500 ">
                                                <caption className="underline cursor-pointer font-[700] text-[#000080] py-2 md:text-md text-lg" onClick={() => setShowMeasurement(true)}>
                                                    How to Measure Size
                                                </caption>
                                                <caption className="font-[700] text-[#000080] py-2 md:text-md text-lg">
                                                    Men Bracelets Size
                                                </caption>
                                                <tr className="text-center">
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Size
                                                    </th>
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Length (inches)
                                                    </th>
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Length (cm)
                                                    </th>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Small (S)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        6 - 6.5
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        16.5 - 17.8
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Medium (M)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        7 - 7.5
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        17.8 - 19
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Large (L)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        7.5 - 8
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        19 - 20.3
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        X-Large (XL)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        8 - 8.5
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        20.3 - 21.3
                                                    </td>
                                                </tr>
                                            </table> */}

                                            <table className="w-full border-collapse border border-slate-500 ">
                                                <caption className="underline cursor-pointer font-[700] text-[#000080] py-2 md:text-md text-lg" onClick={() => setShowMeasurement(true)}>
                                                    How to Measure Size
                                                </caption>
                                                <caption className="font-[700] text-[#000080] py-2 md:text-md text-lg">
                                                    Bracelets Size
                                                </caption>
                                                <tr className="text-center">

                                                    <th className="w-1/4 border border-slate-300 p-1 md:text-sm text-md">
                                                        Size (inches)
                                                    </th>
                                                    <th className="w-1/4 border border-slate-300 p-1 md:text-sm text-md">
                                                        Size (cm)
                                                    </th>
                                                    <th className="w-1/4 border border-slate-300 p-1 md:text-sm text-md">
                                                        Women's Size
                                                    </th>
                                                    <th className="w-1/4 border border-slate-300 p-1 md:text-sm text-md">
                                                        Men's Size
                                                    </th>
                                                </tr>
                                                {sizeChartData.map((item, index) => (
                                                    <tr key={index} className="text-center">
                                                        <td className="border border-slate-300 p-1 md:text-sm text-md">{item.sizeInch}</td>
                                                        <td className="border border-slate-300 p-1 md:text-sm text-md">{item.sizeCm}</td>
                                                        <td className="border border-slate-300 p-1 md:text-sm text-md">{item.womenLabel}</td>
                                                        <td className="border border-slate-300 p-1 md:text-sm text-md">{item.menLabel}</td>
                                                    </tr>
                                                ))}
                                            </table>

                                            {/* <img src="/braceletsChart.jpg" alt="Asset Preview" className="w-full object-contain rounded" loading="lazy" /> */}
                                        </div>
                                    </div>
                                    <div className="mt-4 text-right">
                                        <button
                                            className="inline-flex justify-center rounded-md bg-blue-500 px-4 py-2 text-sm text-white hover:bg-blue-600"
                                            onClick={onClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            {/* Show */}
            <ImageDialog
                isOpen={isShowMeasurement}
                onClose={() => setShowMeasurement(false)}
                imageUrl={'/braceletGuidChart.png'}
            />
        </div>
    )
}

export default BraceletsSizeDialog
